import React from "react";

import { Acccordion } from "../../components";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const HealthInformation = () => {
    const { t } = useTranslation();
    const getPatientViewDetailsData = useSelector(
        (state) => state.admin.getPatientViewDetailsData?.data
    );

    const labelMappings = {
        0: { label1: t("patient_Details.right_eye"), label2: t("patient_Details.right_eye") },
        1: { label1: t("patient_Details.moderate_consumption") },
        2: { label1: t("patient_Details.smoking_status") },
        3: { label1: t("patient_Details.fasting_glucose") },
        4: {
            label1:
                t("patient_Details.hba1c"),
        },
        5: { label1: t("patient_Details.fasting_glucose") },
        6: { label1: t("patient_Details.pap_smear_result") },
        7: { label1: t("patient_Details.blood_pressure") },
    };

    const categories = {
        1: { title: t("patient_Details.health_information.health_tracking"), content: [] },
        2: { title: t("patient_Details.health_information.hearing_and_seeing"), content: [] },
        3: { title: t("patient_Details.health_information.digestion_and_nutrition"), content: [] },
        4: { title: t("patient_Details.health_information.chronic_diseases"), content: [] },
        5: { title: t("patient_Details.health_information.recent_medical_history"), content: [] },
        6: { title: t("patient_Details.health_information.medication_intake"), content: [] },
    };

    if (getPatientViewDetailsData?.result?.questionnaireData) {
        getPatientViewDetailsData?.result?.questionnaireData.forEach((question) => {
            const pageNo = question.questionPageNo;
            if (categories[pageNo]) {
                categories[pageNo].content.push({
                    question: question.question,
                    answers: question?.answers,
                });
            }
        });
    }
    if (categories[1]?.content?.length) {
        categories[1].content.forEach((item, index) => {
            if (
                labelMappings[index] &&
                Array.isArray(item.answers) &&
                item.answers.length > 0
            ) {
                categories[1].content[index].answers = item.answers.map((ans) => ({
                    ...ans,
                    label1: labelMappings[index].label1,
                    label2: labelMappings[index].label2,
                }));
            }
        });
    }

    const accordionItems = Object.values(categories).map(
        (category, catIndex) => ({
            title: category.title,
            content: category.content.map((item, index) => (
                <ul className="pd-hi-ul">
                    <li key={index} className="pd-hi-li">
                        <p className="exado-title-seven">
                            {index + 1} : {item.question}
                        </p>
                        <div className="exado-title-six pd-ans-lis-blk">
                            {item?.answers?.map((ans, idx) =>
                                catIndex === 0 ? (
                                    <div className="d-flex" key={`answer-${idx}`}>
                                        <div className="w-25">
                                            {new Date(ans.createdDate)
                                                .toLocaleDateString("en-US", {
                                                    day: "numeric",
                                                    month: "short",
                                                    year: "numeric",
                                                })
                                                .replace(",", "th,")}
                                            {"  "}

                                            {new Date(ans.createdDate).toLocaleTimeString("en-US", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                            })}
                                        </div>
                                        <div className="w-75">
                                            {ans.answer1}  {ans.label1} {ans.answer2} {ans.label2}
                                        </div>
                                    </div>
                                ) : (
                                    <div key={`answer-${idx}`}>
                                        <div> {ans.answer1} </div>
                                        <div> {ans.answer2} </div>
                                    </div>
                                )
                            )}
                        </div>
                    </li>
                </ul>
            )),
        })
    );

    return (
        <div>
            <Acccordion.Acccordion
                items={accordionItems}
                alwaysOpen={false}
                className="acccordian acccordian1"
                Open={<FaCaretUp className="acc-icn" />}
                Close={<FaCaretDown className="acc-icn" />}
            />
        </div>
    );
};

export default HealthInformation;
